import styled from "styled-components";
import { Flex, SectionTitle } from "../../styles/global.syles";

export const ContactInfoFormContent = styled.div`
	max-width: 760px;
	margin: 0 auto;
	background: #f8fafd;
	border: 1.5px solid #e2e8f5;
	border-radius: 20px;
	padding: 45px 40px;
	box-shadow: 0 10px 32px rgba(12, 21, 56, 0.05);

	@media screen and (max-width: 768px) {
		padding: 30px 20px;
	}

	textarea {
		width: 100%;
		font-size: 14px;
		padding: 15px 18px;
		border-radius: 10px;
		border: 1.5px solid #dce2f0;
		background: #ffffff;
		color: #0c1538;
		outline: none;
		resize: vertical;
		min-height: 120px;
		font-family: inherit;
		transition: all 0.25s ease;

		&:focus {
			border-color: #2806f9;
			box-shadow: 0 0 0 3px rgba(40, 6, 249, 0.12);
		}

		&::placeholder {
			color: #94a0b8;
		}
	}

	button {
		color: #ffffff;
		font-size: 15px;
		padding: 14px 36px;
		min-width: 200px;
		text-align: center;
		border: 0;
		border-radius: 30px;
		font-weight: 700;
		background: #2806f9;
		margin: 10px auto 0 auto;
		cursor: pointer;
		transition: all 0.25s ease;
		box-shadow: 0 4px 16px rgba(40, 6, 249, 0.3);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;

		&:hover {
			background: #1e03c2;
			transform: translateY(-2px);
			box-shadow: 0 8px 24px rgba(40, 6, 249, 0.4);
		}
	}

	.input-row {
		@media screen and (max-width: 640px) {
			grid-template-columns: 1fr;
		}
	}
`;
